<template>

<NavComponents />
  
  <div class="container">
    <el-scrollbar max-height="600px">
  
  
        <el-button icon="Search" style="float: right; margin: 5px;" @click="searchUser()" circle />
    
        <input
        class="input-field"
        type="search"
        placeholder="关键词"
        id="keyword"
        style="float: right;"
        />
        
        <table class="table caption-top">
        <caption>
            专业证书
        </caption>
        <thead>
            <tr>
            <th scope="col">证书名称</th>
            <th scope="col">操作</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="professional in professionalList" :key="professional.professionalId">
    
            <td>{{ professional.professionalName }}</td>
            

            <td>
              <router-link class="dropdown-item" :to="{ name: 'ApplyProfessional', params:{professionalId: professional.professionalId}} ">
                <el-button type="primary" class="Btn2" plain>
                    查看证书
                </el-button>
              </router-link>
            </td>
            </tr>
        </tbody>
        </table>
    
    
        <nav aria-label="...">
        <ul class="pagination" style="float: center">
            <li class="page-item" @click="click_page(-2)">
            <a class="page-link" href="#">前一页</a>
            </li>
            <li
            :class="'page-item ' + page.is_active"
            v-for="page in pages"
            :key="page.number"
            @click="click_page(page.number)"
            >
            <a class="page-link" href="#">{{ page.number }}</a>
            </li>
            <li class="page-item" @click="click_page(-1)">
            <a class="page-link" href="#">后一页</a>
            </li>
        </ul>
        </nav>
    </el-scrollbar>
    </div>
    <NavFooter/>
  </template>
    
    <script setup>
    import NavComponents from "@/components/nav/NavComponents.vue";
    import NavFooter from '@/components/nav/NavFooter.vue'

    import { ref, onMounted } from "vue";
    import { ElMessage } from "element-plus";
    import $ from "jquery";
    import { useRoute } from "vue-router";
    import router from "@/router/index";
    
    
    let current_page = 1;
    let keyword = ref('');
    let total_count = 0;
    let pages = ref([]);
    let professionalList = ref([]);
  
  
    const Route = useRoute(); //获取到值
         
    const token = localStorage.getItem("token");
  
    // 在组件初始化时获取路由参数并设置为 current_page
    onMounted(() => {
      // 获取路由参数并设置为 current_page
      current_page = parseInt(Route.params.page) || 1;
      keyword.value = Route.params.keyword || '';
    
      pullProfessional(current_page, keyword.value);
    });
    
    
    // 加载记录信息
    const pullProfessional = (page, keyword) => {
      current_page = page;
  
      $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/getProfessionalList",
        data: {
          page: page,
          keyword: keyword,
          getAll: false
        },
        type: "post",
        headers: {
          Authorization: "Bearer " + token,
        },
        success(resp) {
            professionalList.value = resp.data.list;
            total_count = resp.data.total;
            udpate_pages();
        },
        error() {
          ElMessage({
            type: "error",
            message: "拉取信息失败!"
          });
        },
      });
    };
    
    const click_page = (page) => {
      if (page === -2) page = current_page - 1;
      else if (page === -1) page = current_page + 1;
      let max_pages = parseInt(Math.ceil(total_count / 10));
    
      if (page >= 1 && page <= max_pages) {
        let keyword = $("#keyword").val();
        pullProfessional(page, keyword);
      }
    };
    
    const udpate_pages = () => {
      let max_pages = parseInt(Math.ceil(total_count / 10));
      let new_pages = [];
      for (let i = current_page - 2; i <= current_page + 2; i++) {
        if (i >= 1 && i <= max_pages) {
          new_pages.push({
            number: i,
            is_active: i === current_page ? "active" : "",
          });
        }
      }
      pages.value = new_pages;
      let keyword = $("#keyword").val();
      router.push({ name: 'LearnProfessional', params: { page: 1,  keyword: keyword } });
    };
    
    const searchUser = () => {
      let keyword = $("#keyword").val();
      pullProfessional(1, keyword);
    }

  </script>
    
    <style scoped>
  
    .avatar{
      width: 50px;
    }
  
  .input-field {
   width: 300px; /* 输入框宽度 */
   padding: 5px;
   border: 1px solid #ccc; /* 边框样式 */
   border-radius: 5px; /* 边框圆角 */
   font-size: 16px; /* 字体大小 */
   outline: none; /* 去除默认轮廓 */
  }
  .input-field:hover,
  .input-field:focus {
   border-color: #66afe9; /* 修改边框颜色 */
   box-shadow: 0 0 5px rgba(102, 175, 233, 0.6); /* 添加阴影效果 */
  }
  
  .addBtn {
    float: right;
    margin: 10px;
  }
  
  .dataBorder {
    margin: 5px;
    background-color: rgba(255, 255, 255, 0.821);
    border: 1px solid rgb(174, 174, 174);
    border-radius: 20px;
  }
  
  .dataBorder:hover{
    margin: 5px;
    background-color: rgba(225, 225, 225, 0.389);
    border: 1px solid rgb(174, 174, 174);
    border-radius: 20px;
    transition: 200ms;
  }
  .courseImg {
    width: 200px;
    margin: 5px;
    border-radius: 20px;
  }
  
  .Btn2 {
    margin: 5px;
  }
  .font_1 {
    color: #656565;
    font-size: 20px;
    font-weight: bold;
    margin-left: 20px;
  }
  </style>